const DOG_BOARDING_RATE_DETAILS = [
  {
    id: 1,
    serviceRateLabel: "Rate per night",
    maxPrice: 120,
    minPrice: 13,
  },
  {
    id: 2,
    serviceRateLabel: "Rate for each additional pet",
    maxPrice: 120,
    minPrice: 8,
  },
];

const DOGGY_DAY_CARE_RATE_DETAILS = [
  {
    id: 1,
    serviceRateLabel: "Rate per day",
    maxPrice: 90,
    minPrice: 15,
  },
  {
    id: 2,
    serviceRateLabel: "Rate for each additional pet",
    maxPrice: 90,
    minPrice: 5,
  },
];

const DOG_WALKING_CARE_RATE_DETAILS = [
  {
    id: 1,
    serviceRateLabel: "Rate per walk",
    maxPrice: 50,
    minPrice: 8,
  },
  {
    id: 2,
    serviceRateLabel: "Rate for each additional pet",
    maxPrice: 50,
    minPrice: 4,
  },
];

const ONE_HOME_VISIT_RATE_DETAILS = [
  {
    id: 1,
    serviceRateLabel: "Rate for one visit a day",
    maxPrice: 60,
    minPrice: 8,
  },
];

const TWO_HOME_VISIT_RATE_DETAILS = [
  {
    id: 1,
    serviceRateLabel: "Rate for two visits a day",
    maxPrice: 100,
    minPrice: 15,
  },
];

const HOUSE_SITTING_RATE_DETAILS = [
  {
    id: 1,
    serviceRateLabel: "Rate for house sitting - 24h care",
    maxPrice: 150,
    minPrice: 25,
  },
];

export {
  DOG_BOARDING_RATE_DETAILS,
  DOGGY_DAY_CARE_RATE_DETAILS,
  DOG_WALKING_CARE_RATE_DETAILS,
  ONE_HOME_VISIT_RATE_DETAILS,
  TWO_HOME_VISIT_RATE_DETAILS,
  HOUSE_SITTING_RATE_DETAILS,
};
